import { useQueryParamHelper } from '@shared/core/queryString';
import { useStaysSearchParams } from '@shared/components/SearchParamsObserver/SearchParamsObserver';

export const useAccommodationsConsoleSearchParamsHelper = () => {
  return useQueryParamHelper();
};

export const useValidatedAccommodationsConsoleSearchParams = () => {
  return useStaysSearchParams();
};
